import { Component, OnInit, Input, HostBinding, OnChanges, SimpleChange } from '@angular/core';
import { AccountService } from '../../services/account.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-super-admin-side-menu',
  templateUrl: './super-admin-side-menu.component.html',
  styleUrls: ['./super-admin-side-menu.component.scss'],
})
export class SuperAdminSideMenuComponent implements OnInit, OnChanges {
  @Input() isCollapsed = false;
  @HostBinding('class.collapse') true;
  @HostBinding('class.in') isCollapsedMenu;
  currentUser: any;
  totalUnreadChatCount: number;
  isCreateProductPriviledges: any;
  isSuperAdmin: boolean;
  userManagementPre;
  viewEditPrdSignup;
  constructor(private accountService: AccountService, private router: Router) {}

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();

    this.isSuperAdmin = this.currentUser.priviledges.some((priviledge) => priviledge === 'ADMIN_OPTIONS') || false;

    this.userManagementPre = this.currentUser.priviledges.some((priviledge) => priviledge === 'MANAGE_ADMIN_USERS') || false;
    this.viewEditPrdSignup =
      this.currentUser.priviledges.some(
        (priviledge) => priviledge === 'REVIEW_PRODUCT_SIGNUP' || priviledge === 'MONITOR_PRODUCT_SIGNUPS'
      ) || false;
  }
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['isCollapsed']) {
      this.isCollapsedMenu = this.isCollapsed;
    }
  }
}
